<template>
  <div>
    <Icon :type="item" v-for="(item, index) in iconList" :key="index" size="24" @click.native="$emit('copyIcon', item)" style="margin-right:5px;cursor: pointer"></Icon>
  </div>
</template>
<script>
export default {
  name: 'icon-list',
  data () {
    return {
      iconList: [
        'ios-add-circle-outline',
        'md-analytics',
        'logo-angular',
        'ios-basketball',
        'md-bookmarks',
        'md-browsers',
        'md-bug',
        'ios-bus-outline',
        'ios-briefcase',
        'md-apps',
        'ios-analytics',
        'ios-albums',
        'ios-albums-outline',
        'md-alert',
        'ios-american-football',
        'md-arrow-dropleft-circle',
        'md-add',
        'md-add-circle',
        'ios-alarm',
        'md-alarm',
        'md-albums',
        'ios-aperture',
        'md-aperture',
        'logo-apple',
        'ios-appstore',
        'md-appstore',
        'ios-arrow-down',
        'md-arrow-back',
        'ios-arrow-back',
        'ios-arrow-dropdown',
        'ios-arrow-dropdown-circle',
        'md-archive',
        'ios-archive',
        'ios-at-outline',
        'md-at',
        'md-attach',
        'md-boat',
        'ios-book',
        'md-bonfire',
        'ios-boat',
        'ios-beer',
        'md-battery-charging',
        'md-basket',
        'ios-bonfire',
        'ios-bluetooth',
        'logo-bitcoin',
        'md-bicycle',
        'ios-body',
        'ios-attach',
        'ios-calculator',
        'ios-camera',
        'md-arrow-round-down',
        'md-chatbubbles',
        'md-bus',
        'ios-arrow-dropright-circle',
        'md-cafe',
        'md-bluetooth',
        'md-cog',
        'md-construct',
        'md-compass',
        'ios-contacts',
        'md-contact',
        'md-contrast',
        'md-cloud-upload',
        'ios-card-outline',
        'ios-baseball',
        'ios-arrow-dropright',
        'ios-eye',
        'ios-easel',
        'md-flask',
        'md-download',
        'ios-cut',
        'md-cloudy',
        'md-checkmark-circle',
        'ios-cart-outline',
        'ios-browsers',
        'md-book',
        'md-desktop',
        'ios-cloudy-night-outline',
        'md-cloud-outline',
        'md-camera',
        'ios-call',
        'md-bowtie',
        'md-backspace',
        'ios-aperture-outline',
        'ios-paper-plane',
        'md-medkit',
        'md-unlock',
        'logo-tux',
        'md-trash',
        'md-trophy',
        'md-videocam',
        'ios-text',
        'md-swap',
        'logo-steam',
        'md-stats',
        'ios-star',
        'md-speedometer',
        'logo-sass',
        'md-pulse',
        'logo-python',
        'ios-pricetags',
        'md-print',
        'md-pin',
        'md-partly-sunny',
        'md-nuclear',
        'ios-mail-open',
        'ios-list-box',
        'md-laptop',
        'md-jet',
        'ios-key',
        'ios-images',
        'md-home',
        'md-help-circle',
        'ios-happy',
        'md-hammer',
        'md-git-pull-request',
        'md-git-compare',
        'md-battery-charging',
        'md-calculator',
        'md-chatbubbles',
        'logo-chrome',
        'md-clock',
        'md-cloud-done',
        'md-cloud-upload',
        'logo-codepen',
        'md-cog',
        'md-compass',
        'md-color-palette',
        'ios-construct',
        'md-cube',
        'md-egg',
        'md-filing',
        'md-finger-print',
        'md-flame',
        'ios-flower',
        'logo-freebsd-devil',
        'ios-funnel',
        'logo-github',
        'md-hand',
        'ios-heart',
        'md-hand',
        'ios-help-buoy',
        'ios-ice-cream',
        'md-images',
        'logo-javascript',
        'ios-locate',
        'md-map',
        'md-medical',
        'logo-octocat',
        'md-pie',
        'md-planet'
      ]
    }
  }
}
</script>

<style>
</style>
